import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

// Property summary model (for detail model see ShortTermRentalPropertyDetail)
export default class ShortTermRentalProperty extends Model {
  [Type] = 'short-term-rental-property' as const;

  @attr('number') declare lat: number;
  @attr('number') declare lng: number;
  @attr declare name: string;
}
